// extracted by mini-css-extract-plugin
module.exports = {"card":"Services2_card__uizfi","footer":"Services2_footer__3p0Pv"};